import { mustNotBeBlankValidator } from '../../../../../common/utils';
import { FormControl, Validators } from '@angular/forms';
import { PlantExternalIdType } from '../constants';

export class PlantExtIdsModel {
  id = '';
  type: PlantExternalIdType | string = '';
  constructor(params?: PlantExtIdsModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlantExtIdsForm {
  constructor(
    extIdModel: PlantExtIdsModel,
    hasUpdatePermission: boolean = true,
    public id: FormControl<string> = new FormControl<string>({ value: extIdModel.id, disabled: !hasUpdatePermission }, [
      Validators.required,
      mustNotBeBlankValidator,
    ]),
    public type: FormControl<PlantExternalIdType | string> = new FormControl<PlantExternalIdType | string>(
      { value: extIdModel.type, disabled: !hasUpdatePermission },
      [Validators.required],
    ),
  ) {}
}

export interface PlantExternalId {
  type: PlantExternalIdType;
  id: string;
}

export interface PlantExtIdsRequestModel {
  type: PlantExternalIdType;
  search: string;
}
